<h4 translate="tariff.selectionCard.priceDetailsTitle" data-force-focus="back"></h4>

@let items = selectedTariff()?.priceIndication?.preisbestandteile?.produktAttribute;
@for (item of items; track item.name) {
  <mwe-tariff-selection-card-collapse-item [item]="item" (collapseToggleClicked)="onCollapseToggleClicked()" />
}
